import axios from 'axios';

export default {
    fetchImages: async (query) => {
        const url = `/app/unsplash/search?query=${query}`;
        const res = await axios.get(url).catch(err => console.log({err}));
        return res.data || [];
    },
};
